import { render, staticRenderFns } from "./result.vue?vue&type=template&id=4c333332"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports